import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL, generateRandomPassword } from "../../../utility";
import { useForm } from "react-hook-form";
import Loader from "../../common/Loader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SweetAlert from "react-bootstrap-sweetalert";
import { MdOutlineContentCopy } from "react-icons/md";
import { CopyToClipboard } from 'react-copy-to-clipboard';

const EditUser = () => {
    const [isChecked, setIsChecked] = useState(true);

    const { register, handleSubmit, reset, watch, formState: { errors }, } = useForm();

    const { id } = useParams();

    const navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [flag, setFlag] = useState(2);

    const [loading, setLoading] = useState(true);

    const [showPassword, setShowPassword] = useState(false);
    const [show, setShow] = useState(false);


    useEffect(() => {
        const token = localStorage.getItem("admin_token");
        // console.log("token : ", token);
        axios.get(`${API_URL}/admin/users/${id}`, { headers: { 'Authorization': `Bearer ${token}` } }).then((res) => {
            // console.log("View User res : ", res);
            setUser(res?.data?.user);
            const resObj = res?.data?.user;
            const resObj2 = res?.data;
            setIsChecked(resObj?.status === 1 ? true : false);
            reset({ ...resObj, password: resObj?.passtr, company_name: resObj2?.billInfo?.company_name, company_phone: resObj2?.billInfo?.company_phone, company_address: resObj2?.billInfo?.company_address, company_tax_id: resObj2?.billInfo?.company_tax_id });
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            // console.log("View User error : ", err);
        })
    }, [flag])

    const onSubmit = (data) => {
        setLoading(true);
        // console.log("data : ", data);
        const token = localStorage.getItem("admin_token");
        axios.post(`${API_URL}/admin/users/${id}/edit`, { ...data, user_account: user?.user_account, status: isChecked ? "1" : "0" }, { headers: { 'Authorization': `Bearer ${token}` } }).then((res) => {
            // console.log("User update res : ", res);
            // localStorage.setItem("admin_token", res?.data?.token);
            setLoading(false);
            toast.success("User updated successfully");
            setTimeout(() => {
                navigate('/users');
            }, 6000)
        }).catch((err) => {
            // console.log("User update Error : ", err);
            // if(err?.response?.status === 500){
            //     toast.error("Server Error");
            // }
            if (err?.response?.data?.type === "API") {
                toast.error(err?.response?.data?.error);
                toast.error(err?.response?.data?.from);
            } else {
                toast.error(err?.response?.data?.error?.name ? err?.response?.data?.error?.name[0] : err?.response?.data?.error?.email ? err?.response?.data?.error?.email[0] : err?.response?.data?.error?.address ? err?.response?.data?.error?.address[0] : err?.response?.data?.error?.phone_number ? err?.response?.data?.error?.phone_number[0] : err?.response?.data?.error?.company ? err?.response?.data?.error?.company[0] : err?.response?.data?.error?.password ? err?.response?.data?.error?.password[0] : "Server Error");
            }
            setLoading(false);
            // setError(err?.response?.data?.message);
        })
    }

    const copyPassword = () => {
        // user?.passtr?.select();
        // user?.passtr?.setSelectionRange(0, 99999); // For mobile devices

        const text = watch("password");

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(function () {
                // console.log('Text copied to clipboard');
                toast.success("Password copied to clipboard successfully");
            }).catch(function (error) {
                // console.error('Failed to copy text: ', error);
            });
        } else {
            var textArea = document.createElement('textarea');
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                // console.log('Text copied to clipboard');
                toast.success("Password copied to clipboard successfully");
            } catch (err) {
                // console.error('Failed to copy text: ', err);
            }
            document.body.removeChild(textArea);
        }

        // Copy the text inside the text field
        // navigator.clipboard.writeText(watch("password"));
        // toast.success("Password copied to clipboard successfully");
    }

    // if(loading){
    //     return (
    //         <Loader />
    //     )
    // } else {
    return (
        <div className="staff-detail-page">
            {show && (
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Yes Sure!"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="secondary"
                    title="Are you sure?"
                    onConfirm={() => { reset({ password: generateRandomPassword(9) }); setShow(false) }}
                    onCancel={() => { setShow(false) }}
                    focusCancelBtn
                >
                    You want to generate password
                </SweetAlert>
            )}
            <ToastContainer />
            {loading ? (<Loader />) : (
                <>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <h1 className="staffName mt-3">{user?.user_account}</h1>
                        <h6 className="breadCrumbs mt-4 pb-3">
                            <span onClick={() => navigate('/users')} className="pointer">
                                User
                            </span>
                            <span className="greater-than"> &#62; </span>
                            <span onClick={() => navigate(`/users/view-user/${id}`)} className="pointer">{user?.user_account}</span>
                            <span className="greater-than"> &#62; </span>
                            <span className="viewUserText">Edit User</span>
                        </h6>  

                        <h3 className="staffdetail-sub-heading mt-4 mb-0">Information</h3>
                        <div className="d-flex pt-3">
                            <div className="div1 w-75" style={{ maxWidth: '840px' }}>

                                <div className="d-flex flex-row align-items-center pb-2 pt-2">
                                    <p className="displayBlockText">Status</p>
                                    <p className="displayBlockText">
                                        <div className='switch-btn-div d-flex align-items-center'>
                                            <input id="switch-status" type="checkbox"
                                                onChange={(e) => { setIsChecked(e.target.checked); }}
                                                defaultChecked={isChecked}
                                                name="check"
                                                value={true}
                                                class="toggle-station" />
                                            <label for="switch-status"
                                                className={isChecked ? "switch-active-label"
                                                    : "switch-active-label swith-off"}>
                                                {isChecked ? 'Enable' : 'Disable'}
                                            </label>
                                        </div>
                                    </p>
                                </div>

                                <div className="d-flex flex-row align-items-center pb-2 pt-2">
                                    <p className="displayBlockText">User account</p>
                                    <p className="displayBlockText fw-bold">{user?.user_account}</p>
                                </div>

                                <div className="d-flex flex-row align-items-center">
                                    <p className="displayBlockText">Name</p>
                                    <div className="d-flex flex-row align-items-center pe-4 mt-2 mb-2">
                                        <div className="me-2 ms-4" style={{ minWidth: '150px' }}>
                                            <input type="text"
                                                {...register("name", { required: true })}
                                                className="searchBox w-100" />
                                        </div>
                                        <p className="displayBlockText" style={{ minWidth: "100px" }}>Surname</p>
                                        <div className="ms-3" style={{ minWidth: '150px' }}>
                                            <input type="text" {...register("surename", { required: true })} className="searchBox w-100" />
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex flex-row align-items-center">
                                    <p className="displayBlockText">Address</p>
                                    <p className="displayBlockText w-100">
                                        <input type="text" {...register("address", { required: true })} className="searchBox w-100" />
                                    </p>
                                </div>

                                <div className="d-flex flex-row align-items-center">
                                    <p className="displayBlockText">Email</p>
                                    <p className="displayBlockText w-100">
                                        <input type="text" {...register("email", { required: true })} className="searchBox w-100" />
                                    </p>
                                </div>

                                <div className="d-flex flex-row align-items-center">
                                    <p className="displayBlockText">Phone</p>
                                    <p className="displayBlockText w-100">
                                        <input type="text" {...register("phone_number", { required: true })} className="searchBox w-100" />
                                    </p>
                                </div>

                                <div className="d-flex flex-row align-items-center">
                                    <p className="displayBlockText">Company</p>
                                    <p className="displayBlockText w-100">
                                        <input type="text" {...register("company", { required: true })} className="searchBox w-100" />
                                    </p>
                                </div>

                            </div>
                        </div>

                        <h3 className="staffdetail-sub-heading mt-4 mb-0">Reset Password</h3>
                        <div className="adf d-flex w-75 mt-4 ms-4">
                            <div className="w-75 pe-2" style={{ maxWidth: '600px' }}>
                                {/* <p className="mb-1 mt-3">Password <span className="text-danger">*</span></p> */}
                                <div className="p-relative">
                                    <input {...register("password")} type={showPassword ? "text" : "password"} className="searchBox w-100" />
                                    <svg onClick={() => setShowPassword(!showPassword)} className="eye-icon-gen pointer" cla xmlns="http://www.w3.org/2000/svg" width="33.75" height="22.5" viewBox="740 700.75 33.75 22.5"><path d="M773.546 711.145c-3.178-6.2-9.468-10.395-16.671-10.395-7.203 0-13.495 4.198-16.671 10.395a1.896 1.896 0 0 0 0 1.71c3.177 6.2 9.468 10.395 16.67 10.395 7.204 0 13.496-4.198 16.672-10.395a1.895 1.895 0 0 0 0-1.71Zm-16.671 9.293a8.438 8.438 0 1 1 8.437-8.438 8.433 8.433 0 0 1-8.437 8.438Zm0-14.063c-.502.007-1.001.082-1.483.222a2.804 2.804 0 0 1-3.92 3.92 5.612 5.612 0 1 0 5.403-4.142Z" fill="#d2d2d2" fill-rule="evenodd" data-name="Icon awesome-eye" /></svg>
                                    <CopyToClipboard
                                        text={watch("password")}
                                        onCopy={() => { toast.success("Password copied to clipboard successfully"); }}
                                    >
                                        <MdOutlineContentCopy color="#d2d2d2" className="copy-icon" size={"0.55cm"} />

                                    </CopyToClipboard>
                                </div>
                            </div>
                            <div className="w-fit-content mb-2">
                                <button type="button" onClick={() => { setShow(true); }} className="pointerButton pe-5 ps-5 ms-4">Generate</button>
                            </div>
                        </div>

                        <h3 className="staffdetail-sub-heading mt-4 mb-0">Bill Information</h3>
                        <div className="d-flex pt-3">
                            <div className="div1 w-75" style={{ maxWidth: '840px' }}>
                                <div className="d-flex flex-row align-items-center">
                                    <p className="displayBlockText">Company</p>
                                    <p className="displayBlockText w-100">
                                        <input type="text" {...register("company_name")} className="searchBox w-100"/>
                                    </p>
                                </div>
                                <div className="d-flex flex-row align-items-center">
                                    <p className="displayBlockText">Company Address</p>
                                    <p className="displayBlockText w-100">
                                        <input {...register("company_address")} type="text" className="searchBox w-100" />
                                    </p>
                                </div>
                                <div className="d-flex flex-row align-items-center">
                                    <p className="displayBlockText">Phone</p>
                                    <p className="displayBlockText w-100">
                                        <input type="number" {...register("company_phone")} className="searchBox w-100" />
                                    </p>
                                </div>
                                <div className="d-flex flex-row align-items-center">
                                    <p className="displayBlockText">TAX ID</p>
                                    <p className="displayBlockText w-100">
                                        <input type="number" {...register("company_tax_id")} className="searchBox w-100" />
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex mt-4 mb-5">
                            <button type="submit" className="pointerButton px-5">Submit</button>
                            <button className="secondaryPointerButton ms-4 px-5" type="button" onClick={() => navigate('/users')}>Cancel</button>
                        </div>
                    </form>
                </>
            )}
        </div>
    )
    // }
}

export default EditUser;